import React from 'react'
import { ProfileInfo } from '../../organism'
import ProfileStyled from './styled'

const Profile = () => {
  return (
    <ProfileStyled>
      <ProfileInfo />
    </ProfileStyled>
  )
}

export default Profile
